import React, { useState, useEffect, useCallback } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Quote, ChevronLeft, ChevronRight } from "lucide-react";
import { SectionHeading } from "./shared";
import { TESTIMONIALS } from "../data";

export const Testimonials = () => {
  const [index, setIndex] = useState(0);
  const count = TESTIMONIALS.length;

  const go = useCallback((dir) => setIndex((i) => (i + dir + count) % count), [count]);

  useEffect(() => {
    const t = setInterval(() => setIndex((i) => (i + 1) % count), 6000);
    return () => clearInterval(t);
  }, [count]);

  const t = TESTIMONIALS[index];

  return (
    <section id="testimoniale" className="bg-white py-20 lg:py-28">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeading
          center
          eyebrow="Testimoniale"
          title="Ce spun clienții noștri"
          subtitle="Încrederea companiilor cu care lucrăm este cea mai bună recomandare a noastră."
        />

        <div className="mt-14 relative">
          <div className="relative rounded-3xl bg-[#F8F9FA] ring-1 ring-black/5 px-8 py-12 sm:px-14 sm:py-14 overflow-hidden flex flex-col">
            <Quote className="mx-auto h-10 w-10 text-brand/25 shrink-0" fill="currentColor" />
            <div className="relative mt-6 min-h-[260px] sm:min-h-[220px] lg:min-h-[190px]">
              <AnimatePresence mode="wait">
                <motion.div
                  key={index}
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  transition={{ duration: 0.35, ease: "easeInOut" }}
                  data-testid="testimonial-active"
                  className="absolute inset-0 flex flex-col justify-center text-center"
                >
                  <p className="text-xl sm:text-2xl font-medium text-ink leading-relaxed">
                    “{t.quote}”
                  </p>
                  <div className="mt-8">
                    <p className="text-base font-bold text-ink">{t.name}</p>
                    <p className="text-sm text-brand font-medium">{t.role}</p>
                  </div>
                </motion.div>
              </AnimatePresence>
            </div>
          </div>

          <div className="mt-8 flex items-center justify-center gap-4">
            <button
              onClick={() => go(-1)}
              data-testid="testimonial-prev"
              aria-label="Testimonialul anterior"
              className="flex h-11 w-11 items-center justify-center rounded-full border border-gray-300 text-ink hover:border-brand hover:text-brand transition-colors"
            >
              <ChevronLeft className="h-5 w-5" />
            </button>
            <div className="flex items-center gap-2">
              {TESTIMONIALS.map((_, i) => (
                <button
                  key={i}
                  onClick={() => setIndex(i)}
                  data-testid={`testimonial-dot-${i}`}
                  aria-label={`Testimonialul ${i + 1}`}
                  className={`h-2.5 rounded-full transition-all duration-300 ${
                    i === index ? "w-7 bg-brand" : "w-2.5 bg-gray-300 hover:bg-gray-400"
                  }`}
                />
              ))}
            </div>
            <button
              onClick={() => go(1)}
              data-testid="testimonial-next"
              aria-label="Testimonialul următor"
              className="flex h-11 w-11 items-center justify-center rounded-full border border-gray-300 text-ink hover:border-brand hover:text-brand transition-colors"
            >
              <ChevronRight className="h-5 w-5" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};
